// src/pages/History/AncientHistory/HistoryPageGreece.js
import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Classical_Antiquity_-_Ancient_Greece.png';


export default function HistoryPageGreece() {
  return (
    <TopicPage
      topicKey="Ancient Greece"
      title="History: Ancient Greece"
      backgroundImage={bg}
      startRoute="/History-Ancient-Greece-Go"
      scrollLabels={[
        "Greek City-States",
        "Philosophy and Democracy",
        "Warfare and Culture",
      ]}
  backRoute="/history-Classical-Antiquity"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}
